import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { InfoManutencao } from './EmManutencao.styled';
import { Button } from '../Button/Button.styled';
import { PageTitle } from '~/components';
import { MODO_VISAO } from '~/modules/Helper/modoVisao';
import * as ModuloVisaoService from '../../modules/Modulos/services/moduloVisao.service';

/**
 * Query esperada (vindo do ModuloDinamico):
 *   /manutencao?visao=dinamico/{modulo}/{visao}&titulo=...
 * Formato do param visao: {tipo}/{modulo}/{visaoNome}
 */
function extrairModuloVisao(visaoParam) {
  const parts = (visaoParam || '').split('/').filter(Boolean);

  if (parts.length >= 3) {
    return { moduloApi: parts[1], visaoApi: parts[2] };
  }

  if (parts.length === 2) {
    return { moduloApi: parts[0], visaoApi: parts[1] };
  }

  return { moduloApi: null, visaoApi: null };
}

function EmManutencao() {
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const visaoParam = params.get('visao');
  const titulo = params.get('titulo') || '';
  const { moduloApi, visaoApi } = extrairModuloVisao(visaoParam);
  const [botaoDisabled, setBotaoDisabled] = useState(true);

  useEffect(() => {
    if (!moduloApi || !visaoApi) {
      return undefined;
    }

    let cancelado = false;

    const verificarModoVisao = async () => {
      try {
        const responseConfiguracao = await ModuloVisaoService.obterConfiguracoes(
          moduloApi,
          visaoApi
        );

        if (cancelado) return;

        const modoVisao = responseConfiguracao?.data?.ModoVisao;
        if (modoVisao !== MODO_VISAO.Manutencao) {
          setBotaoDisabled(false);
        }
      } catch {
        // Mantém botão "Voltar para a Home" se a consulta falhar.
        // Evita depender do interceptor global de 404 para a UX desta tela.
      }
    };

    verificarModoVisao();

    return () => {
      cancelado = true;
    };
  }, [moduloApi, visaoApi]);

  const voltarParaVisao = () => {
    if (botaoDisabled || !visaoParam) {
      history.push('/');
      return;
    }

    history.push(`/${visaoParam}`);
  };

  const textoBotao = botaoDisabled
    ? 'Voltar para a Home'
    : 'Voltar para a Visão';

  const tituloExibicao = titulo || 'solicitada';

  const tituloPagina = botaoDisabled
    ? `Visão '${tituloExibicao}' em manutenção temporária.`
    : `Visão '${tituloExibicao}' sofreu uma alteração.`;

  const subTituloPagina = botaoDisabled
    ? 'Tente novamente mais tarde.'
    : 'Clique aqui para atualizar';

  return (
    <>
      <PageTitle titulo={tituloPagina} />
      <InfoManutencao
        status="info"
        subTitle={subTituloPagina}
        extra={
          <Button type="primary" onClick={voltarParaVisao}>
            {textoBotao}
          </Button>
        }
      />
    </>
  );
}

export default EmManutencao;
